const themeTableView = () => import('@/views/main/dataList/themeTableView.vue')
export default {
  path: '/main/dataList/themeTableView/:id',
  name: 'themeTableView',
  component: themeTableView,
  children: []
}
